import React from 'react';
import { getActionNeededList } from 'api/credentialing';
import type { TCredentialingPanelAction } from 'types/credentialing';

let globalData: TCredentialingPanelAction[] = [];

const useActionNeeded = (): [TCredentialingPanelAction[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingPanelAction[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getActionNeededList();
            if (!result.error) {
                const list: TCredentialingPanelAction[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useActionNeeded;
